import { BsFillSkipEndCircleFill } from "react-icons/bs"

export const icons= [
    {
      id: 1,
      text: <BsFillSkipEndCircleFill />,
    },
    {
      id: 2,
      text: <BsFillSkipEndCircleFill />,
    },
    {
      id: 3,
      text: <BsFillSkipEndCircleFill />,
    },
    {
      id: 4,
      text: <BsFillSkipEndCircleFill />,
    }
  ];

export const numbers = [
  {
    id: 1,
    text: 1
  },
  {
    id: 2,
    text: 2
  },
  {
    id: 3,
    text: 3
  },
  
]